import React from 'react';
import { Form, Select } from 'antd';

const ADDITIONAL_FILES_TYPE_OPTIONS = [
    {
        value: 'For Reference Only',
        label: 'For Reference Only (Other File Types and Misc.)',
    },
    {
        value: 'Manufacturing Information or Specification',
        label: 'Manufacturing Information or Specification',
    },
    {
        value: 'PO for Requote Review',
        label: 'PO for Requote Review',
    },
    {
        value: 'Target Price/Lead Time for Review',
        label: 'Target Price/Lead Time for Review',
    },
    {
        value: 'Multiple Reasons',
        label: 'Multiple Reasons',
    },
];

interface AdditionalFilesTypeSelectProps {
    initialValue?: string | null;
    required?: boolean;
    onUpdate: (field: string, value: string | null) => void;
}

const AdditionalFilesTypeSelect: React.FC<AdditionalFilesTypeSelectProps> = ({
    initialValue,
    required = true,
    onUpdate,
}) => {
    return (
        <Form.Item
            name="additional_files_type"
            label="File Type"
            rules={[
                {
                    required: required,
                    message: 'Please select a file type',
                },
            ]}
        >
            <Select
                placeholder="Select file type"
                onChange={value => {
                    onUpdate('additional_files_type', value);
                }}
                allowClear
                onClear={() => {
                    onUpdate('additional_files_type', null);
                }}
            >
                {ADDITIONAL_FILES_TYPE_OPTIONS.map(option => (
                    <Select.Option key={option.value} value={option.value}>
                        {option.label}
                    </Select.Option>
                ))}
            </Select>
        </Form.Item>
    );
};

export default AdditionalFilesTypeSelect;
